import _toConsumableArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function i(t, e, n) {
  t.prerender = function () {
    for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
      r[_key] = arguments[_key];
    }
    Object.getPrototypeOf(t).prerender(), n.value.apply(this, r);
  };
}
function o(t, e, n) {
  t.postrender = function () {
    for (var _len2 = arguments.length, r = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      r[_key2] = arguments[_key2];
    }
    Object.getPrototypeOf(t).postrender(), n.value.apply(this, r);
  };
}
function p(t, e, n) {
  t.destroy = function () {
    for (var _len3 = arguments.length, r = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      r[_key3] = arguments[_key3];
    }
    Object.getPrototypeOf(t).destroy(), n.value.apply(this, r);
  };
}
var s = function s(t) {
  return function (e) {
    e.mixins && Array.isArray(e.mixins) && (e.mixins = [].concat(_toConsumableArray(e.mixins), [t]));
  };
};
export { o as i, i as r, s, p as y };